import React, { useState, useEffect } from 'react';
import { getUrlObject } from '../utils/utilityFunctions';

const useTestUrlRedirection = ({ navigate, navListItems, type, urlParam }) => {
  const [selectedNavItem, setSelectedNavItem] = useState(
    navListItems[0]['value']
  );

  useEffect(() => {
    // Skip if type is empty - we're likely on a different tab that doesn't use this param
    if (!type) {
      return;
    }

    const navListValues = navListItems.map((item) => item?.name);
    if (navListValues.includes(type)) {
      navListItems.map((nav) => {
        if (nav?.name === type) {
          setSelectedNavItem(nav?.value);
        }
      });
    } else {
      // Only redirect to default if type was provided but invalid
      const url = getUrlObject();
      url.searchParams.set(urlParam, navListItems[0]['name']);
      navigate(`${url.pathname}${url.search}`, { replace: true });
    }
  }, [type, navigate, navListItems, urlParam]);

  return [selectedNavItem, setSelectedNavItem];
};

export default useTestUrlRedirection;
